import { getBrandBusinessName } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailer, getRetailerBusinessName } from "@faire/help-center-utils/serialized-data/getRetailer";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var UserInfoSummaryCard = function UserInfoSummaryCard() {
  var _getBrandBusinessName;
  var retailer = getRetailer();
  var userBusinessName = (_getBrandBusinessName = getBrandBusinessName()) !== null && _getBrandBusinessName !== void 0 ? _getBrandBusinessName : getRetailerBusinessName();
  return /*#__PURE__*/React.createElement(React.Fragment, null, retailer ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "WIxTl+",
    defaultMessage: [{
      "type": 0,
      "value": "Je account"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), /*#__PURE__*/React.createElement(Typography, null, userBusinessName))) : ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rZxhk0",
    defaultMessage: [{
      "type": 0,
      "value": "Je winkel"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), /*#__PURE__*/React.createElement(Typography, null, userBusinessName))));
};